import { render, staticRenderFns } from "./SessionTimeOutWarning.vue?vue&type=template&id=b68641ec&"
import script from "./SessionTimeOutWarning.vue?vue&type=script&lang=js&"
export * from "./SessionTimeOutWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports